import React from 'react';
import PropTypes from 'prop-types';

const StopNumberOfItemsCell = ({ numberOfItems, typeOfPallets, loadType }) => {
  if (loadType === 'BULK') {
    typeOfPallets = 'Bulk';
  }

  return (
    <div>
      {numberOfItems} {typeOfPallets}
    </div>
  );
};

StopNumberOfItemsCell.propTypes = {
  numberOfItems: PropTypes.number.isRequired,
  typeOfPallets: PropTypes.string.isRequired,
};

export default StopNumberOfItemsCell;
